import { render, staticRenderFns } from "./widget-courseTextResources.vue?vue&type=template&id=360db2f1"
import script from "./widget-courseTextResources.vue?vue&type=script&lang=ts"
export * from "./widget-courseTextResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports